var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3639(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(-0.2 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3639",
    "data-name": "Group 3639",
    transform: "translate(0.2 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3638",
    "data-name": "Group 3638",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50524",
    "data-name": "Path 50524",
    d: "M17.423,23.077H3.884a.423.423,0,0,1-.423-.422V9.116a7.192,7.192,0,1,1,14.385,0V22.655a.423.423,0,0,1-.422.422M4.307,22.231H17V9.116a6.346,6.346,0,0,0-12.693,0Zm6.347-5.5a5.506,5.506,0,0,1-5.5-5.5v-.746A5.624,5.624,0,0,1,7.67,5.795a.422.422,0,0,1,.6.139c.6,1.036,2.537,3.459,7.454,3.6a.423.423,0,0,1,.41.387c.013.168.021.32.021.467v.846a5.506,5.506,0,0,1-5.5,5.5M7.79,6.754A4.774,4.774,0,0,0,6,10.485v.746a4.654,4.654,0,1,0,9.307,0v-.87C10.776,10.121,8.654,8,7.79,6.754",
    transform: "translate(0.346 0.192)",
    fill: "#1d1d1d",
    stroke: "#1d1d1d",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50525",
    "data-name": "Path 50525",
    d: "M15.116,21.863H5.807a.423.423,0,0,1-.422-.424,5.668,5.668,0,0,1,2.961-4.562V15.038a.423.423,0,1,1,.846,0v2.115a.421.421,0,0,1-.272.395c-.025.01-2.368,1.415-2.66,3.468h8.4c-.29-2.054-2.635-3.458-2.66-3.468a.424.424,0,0,1-.272-.395V15.038a.423.423,0,1,1,.846,0v1.839a5.666,5.666,0,0,1,2.962,4.562.424.424,0,0,1-.424.424",
    transform: "translate(0.538 1.462)",
    fill: "#1d1d1d",
    stroke: "#1d1d1d",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3639);
export default __webpack_public_path__ + "static/media/Group3639.8fbc9a744c4c0c2977be09de2d1ef84a.svg";
export { ForwardRef as ReactComponent };